/* VAIRE packshot generator.
   Renders coherent SVG product art from product.vessel + product.colorway.
   This is the placeholder imagery layer: when real photography exists, add
   `images: [...]` to a product and renderers prefer it automatically. */
(function () {
  'use strict';

  const INK = '#16120E';
  let uid = 0;

  function esc(s) { return String(s).replace(/[<>&"]/g, c => ({ '<': '&lt;', '>': '&gt;', '&': '&amp;', '"': '&quot;' }[c])); }

  function shade(hex, amt) { // amt -1..1, negative darkens
    const n = hex.replace('#', '');
    const [r, g, b] = [0, 2, 4].map(i => parseInt(n.substr(i, 2), 16));
    const f = v => Math.max(0, Math.min(255, Math.round(amt < 0 ? v * (1 + amt) : v + (255 - v) * amt)));
    return '#' + [f(r), f(g), f(b)].map(v => v.toString(16).padStart(2, '0')).join('');
  }

  function bodyGrad(id, c) {
    return `<linearGradient id="${id}" x1="0" y1="0" x2="1" y2="0">
      <stop offset="0" stop-color="${shade(c, .28)}"/><stop offset=".42" stop-color="${c}"/>
      <stop offset=".85" stop-color="${shade(c, -.22)}"/><stop offset="1" stop-color="${shade(c, -.32)}"/>
    </linearGradient>`;
  }

  function spec(x, y, w, h, r, o) {
    return `<rect x="${x}" y="${y}" width="${w}" height="${h}" rx="${r}" fill="#fff" opacity="${o || .32}"/>`;
  }

  function label(cx, y, w, no) {
    const h = 44;
    return `<rect x="${cx - w / 2}" y="${y}" width="${w}" height="${h}" rx="3" fill="#F5F0E7" opacity=".94"/>
      <text x="${cx}" y="${y + 19}" text-anchor="middle" font-family="'Space Mono',monospace" font-size="9.5" letter-spacing="2.6" fill="${INK}" opacity=".8">VAIRE</text>
      <text x="${cx}" y="${y + 33}" text-anchor="middle" font-family="'Space Mono',monospace" font-size="6.5" letter-spacing="1.4" fill="${INK}" opacity=".45">NO. ${String(no).padStart(3, '0')}</text>`;
  }

  const shadow = `<ellipse cx="100" cy="247" rx="52" ry="7" fill="${INK}" opacity=".10"/>`;

  const VESSELS = {
    dropper(p, g, cw) {
      return `${shadow}
        <rect x="64" y="96" width="72" height="146" rx="16" fill="url(#${g})"/>
        ${spec(72, 106, 7, 126, 4)}
        <rect x="88" y="78" width="24" height="20" fill="${shade(cw.cap, -.05)}"/>
        <rect x="82" y="52" width="36" height="30" rx="8" fill="${cw.cap}"/>
        ${label(100, 150, 58, p.no)}`;
    },
    pump(p, g, cw) {
      return `${shadow}
        <rect x="68" y="88" width="64" height="154" rx="10" fill="url(#${g})"/>
        ${spec(76, 98, 6, 134, 3)}
        <rect x="90" y="70" width="20" height="20" fill="${shade(cw.cap, -.05)}"/>
        <path d="M84 54 h32 v16 h-14 v-6 h-30 v-10 h12 z" fill="${cw.cap}"/>
        ${label(100, 146, 52, p.no)}`;
    },
    bottle(p, g, cw) {
      return `${shadow}
        <rect x="60" y="92" width="80" height="150" rx="20" fill="url(#${g})"/>
        ${spec(69, 103, 8, 128, 4)}
        <rect x="82" y="60" width="36" height="34" rx="6" fill="${cw.cap}"/>
        ${label(100, 152, 62, p.no)}`;
    },
    jar(p, g, cw) {
      return `${shadow}
        <rect x="44" y="160" width="112" height="82" rx="16" fill="url(#${g})"/>
        ${spec(54, 168, 9, 64, 4)}
        <rect x="40" y="132" width="120" height="30" rx="9" fill="${cw.cap}"/>
        <rect x="40" y="138" width="120" height="4" fill="${shade(cw.cap, .18)}" opacity=".5"/>
        <text x="100" y="205" text-anchor="middle" font-family="'Space Mono',monospace" font-size="9.5" letter-spacing="2.6" fill="${INK}" opacity=".55">VAIRE</text>`;
    },
    tube(p, g, cw) {
      return `${shadow}
        <rect x="70" y="224" width="60" height="18" rx="5" fill="${cw.cap}"/>
        <path d="M74 82 q26 -18 52 0 l4 142 h-60 z" fill="url(#${g})"/>
        ${spec(80, 92, 6, 116, 3)}
        ${label(100, 140, 50, p.no)}`;
    },
    mist(p, g, cw) {
      return `${shadow}
        <rect x="74" y="98" width="52" height="144" rx="10" fill="url(#${g})"/>
        ${spec(81, 108, 5, 122, 3)}
        <rect x="88" y="82" width="24" height="16" fill="${shade(cw.cap, -.05)}"/>
        <rect x="84" y="60" width="32" height="24" rx="5" fill="${cw.cap}"/>
        <rect x="98" y="66" width="14" height="5" rx="2" fill="${shade(cw.cap, .3)}"/>
        ${label(100, 152, 46, p.no)}`;
    },
    bullet(p, g, cw, hex) {
      const lip = hex || (p.shades && p.shades[0] ? p.shades[0].hex : '#C87878');
      return `${shadow}
        <rect x="70" y="164" width="60" height="78" rx="8" fill="${cw.cap}"/>
        ${spec(77, 170, 6, 64, 3, .2)}
        <rect x="76" y="148" width="48" height="18" rx="3" fill="${shade(cw.accent, .1)}"/>
        <path d="M80 148 v-52 q0 -10 10 -10 h14 q16 8 16 26 v36 z" fill="${lip}"/>
        <path d="M80 148 v-52 q0 -10 10 -10 h6 v62 z" fill="#fff" opacity=".22"/>
        <text x="100" y="212" text-anchor="middle" font-family="'Space Mono',monospace" font-size="8.5" letter-spacing="2.2" fill="#F5F0E7" opacity=".85">VAIRE</text>`;
    },
    gloss(p, g, cw, hex) {
      const c = hex || (p.shades && p.shades[0] ? p.shades[0].hex : '#D69C8B');
      return `${shadow}
        <rect x="80" y="112" width="40" height="130" rx="9" fill="url(#${g})" opacity=".5"/>
        <rect x="80" y="112" width="40" height="130" rx="9" fill="${c}" opacity=".55"/>
        ${spec(86, 120, 4, 112, 2)}
        <rect x="78" y="70" width="44" height="42" rx="6" fill="${cw.cap}"/>
        <text x="100" y="186" text-anchor="middle" font-family="'Space Mono',monospace" font-size="8" letter-spacing="2" fill="${INK}" opacity=".6" transform="rotate(-90 100 186)">VAIRE</text>`;
    },
    pencil(p, g, cw, hex) {
      const c = hex || (p.shades && p.shades[0] ? p.shades[0].hex : '#8A5A44');
      return `${shadow}
        <rect x="88" y="98" width="24" height="144" rx="4" fill="url(#${g})"/>
        ${spec(92, 104, 3, 130, 1.5)}
        <path d="M88 98 l12 -34 l12 34 z" fill="${shade(cw.body, .35)}"/>
        <path d="M95 78 l5 -14 l5 14 z" fill="${c}"/>
        <rect x="88" y="226" width="24" height="16" rx="3" fill="${cw.cap}"/>`;
    },
    compact(p, g, cw, hex) {
      const c = hex || (p.shades && p.shades[0] ? p.shades[0].hex : cw.accent);
      return `<ellipse cx="100" cy="243" rx="58" ry="7" fill="${INK}" opacity=".10"/>
        <circle cx="100" cy="150" r="72" fill="url(#${g})"/>
        <circle cx="100" cy="150" r="72" fill="none" stroke="${shade(cw.body, -.3)}" stroke-width="1"/>
        <circle cx="100" cy="150" r="46" fill="${c}" opacity=".9"/>
        <circle cx="100" cy="150" r="46" fill="url(#${g})" opacity=".18"/>
        <path d="M42 138 a60 60 0 0 1 58 -46" stroke="#fff" stroke-width="7" fill="none" opacity=".28" stroke-linecap="round"/>
        <rect x="92" y="218" width="16" height="7" rx="3" fill="${cw.cap}"/>
        <text x="100" y="230" text-anchor="middle" font-family="'Space Mono',monospace" font-size="0" fill="none"> </text>
        <text x="100" y="98" text-anchor="middle" font-family="'Space Mono',monospace" font-size="8.5" letter-spacing="2.4" fill="${INK}" opacity=".5">VAIRE</text>`;
    },
    palette(p, g, cw) {
      const wells = (p.shades && p.shades.length ? p.shades : [{ hex: '#C9B28A' }, { hex: '#8A5A44' }, { hex: '#D69C8B' }, { hex: '#4A3A2A' }, { hex: '#E4CDA9' }, { hex: '#6E4A32' }])
        .slice(0, 6);
      const cells = wells.map((s, i) => {
        const x = 52 + (i % 3) * 34, y = 148 + Math.floor(i / 3) * 36;
        return `<circle cx="${x}" cy="${y}" r="13" fill="${s.hex}"/><circle cx="${x}" cy="${y}" r="13" fill="none" stroke="${INK}" stroke-opacity=".08"/>`;
      }).join('');
      return `${shadow}
        <rect x="28" y="118" width="144" height="98" rx="10" fill="url(#${g})"/>
        <rect x="36" y="126" width="128" height="82" rx="7" fill="${shade(cw.body, .32)}" opacity=".5"/>
        ${cells}
        <text x="100" y="235" text-anchor="middle" font-family="'Space Mono',monospace" font-size="8.5" letter-spacing="2.4" fill="${INK}" opacity=".55">VAIRE</text>`;
    },
    brush(p, g, cw) {
      return `${shadow}
        <rect x="91" y="128" width="18" height="114" rx="8" fill="url(#${g})"/>
        ${spec(94, 136, 2.5, 98, 1.5)}
        <rect x="88" y="102" width="24" height="28" rx="3" fill="${cw.cap === INK ? '#B08F53' : cw.cap}"/>
        <path d="M88 102 q12 -46 12 -58 q0 12 12 58 z" fill="${shade('#6E4A32', -.1)}"/>
        <path d="M92 100 q8 -34 8 -48 q0 14 3 30 z" fill="#3A2E23" opacity=".6"/>`;
    },
    'wand-tool'(p, g, cw) {
      return `${shadow}
        <rect x="90" y="150" width="20" height="92" rx="9" fill="url(#${g})"/>
        <rect x="96" y="96" width="8" height="56" rx="4" fill="${shade(cw.cap, .1)}"/>
        <path d="M96 96 q-8 -26 4 -40 q12 14 4 40 z" fill="${cw.cap}"/>
        ${spec(93, 156, 3, 78, 1.5)}`;
    },
    'roller-tool'(p, g, cw) {
      return `${shadow}
        <rect x="92" y="146" width="16" height="96" rx="7" fill="url(#${g})"/>
        <path d="M84 146 l-8 -26 m32 26 l8 -26" stroke="${cw.cap}" stroke-width="6" fill="none" stroke-linecap="round"/>
        <ellipse cx="100" cy="102" rx="34" ry="22" fill="url(#${g})"/>
        <ellipse cx="100" cy="102" rx="34" ry="22" fill="${cw.accent}" opacity=".5"/>
        <path d="M74 94 a30 18 0 0 1 30 -12" stroke="#fff" stroke-width="5" opacity=".3" fill="none" stroke-linecap="round"/>`;
    },
    'sculpt-tool'(p, g, cw) {
      return `<ellipse cx="100" cy="235" rx="56" ry="7" fill="${INK}" opacity=".10"/>
        <path d="M52 178 q-14 -34 12 -58 q26 -24 56 -14 q30 10 28 40 q-2 28 -34 34 q-16 3 -28 14 q-16 14 -34 -16 z" fill="url(#${g})"/>
        <path d="M52 178 q-14 -34 12 -58 q26 -24 56 -14 q30 10 28 40 q-2 28 -34 34 q-16 3 -28 14 q-16 14 -34 -16 z" fill="${cw.accent}" opacity=".35"/>
        <path d="M60 128 q22 -22 48 -14" stroke="#fff" stroke-width="6" opacity=".3" fill="none" stroke-linecap="round"/>`;
    },
  };

  function packshotSVG(p, opts) {
    opts = opts || {};
    const cw = p.colorway || { body: '#E4CDA9', accent: '#C9B28A', cap: INK };
    const g = 'psg' + (++uid);
    const fn = VESSELS[p.vessel] || VESSELS.bottle;
    const art = fn(p, g, cw, opts.shadeHex);
    return `<svg viewBox="0 0 200 260" role="img" aria-label="${esc(p.name)}" xmlns="http://www.w3.org/2000/svg"><defs>${bodyGrad(g, cw.body)}</defs>${art}</svg>`;
  }

  /* art(): real product photo when the data has one, generated packshot otherwise */
  function art(p, opts) {
    if (p && p.images && p.images.length) {
      return `<img src="${p.images[0]}" alt="${esc(p.name)}" loading="lazy" decoding="async" style="width:100%;height:100%;object-fit:contain;border-radius:inherit">`;
    }
    return packshotSVG(p, opts);
  }
  window.VairePackshot = { svg: packshotSVG, art };
})();

